'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utils_string_isString = require('./isString.js');

function trim() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (value === null) {
    return '';
  }

  if (utils_string_isString.isString(value)) {
    return value.trim();
  }

  return value;
}

exports.trim = trim;
//# sourceMappingURL=trim.js.map
